import { CompanyListSearchBar } from "@/features/management-settings/components/companies/company-list-search-bar";
import { selectCompanyListViewModel } from "@/features/management-settings/view-models/select-company-list-view-model";
import { Table } from "@spz/ui/components/table";
import { DataTableBody } from "@spz/ui/components/table/data-table-body";
import { DataTableHeader } from "@spz/ui/components/table/data-table-header";
import { DataTablePagination } from "@spz/ui/components/table/data-table-pagination";

import type { FC } from "react";
import { Navigate } from "react-router";

const CompaniesTab: FC = () => {
  const { table, isLoading, hasCompaniesManagementPermission } =
    selectCompanyListViewModel();

  if (!hasCompaniesManagementPermission) {
    return <Navigate to="/403" replace />;
  }
  return (
    <>
      <div className="flex mb-4">
        <div className="w-1/2 max-w-[344px]">
          <CompanyListSearchBar table={table} />
        </div>
      </div>
      <div className="mt-4">
        <Table className="overflow-auto w-full border-collapse border-spacing-0 bg-white">
          <DataTableHeader table={table} />
          <DataTableBody table={table} isLoading={isLoading} />
        </Table>
        <DataTablePagination
          table={table}
          entityLabel="pagination_entity_companies"
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default CompaniesTab;
